export * from '@white-label-store/user-info';
